import React, { useEffect, useState } from "react";

import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ProgressBar from "@ramonak/react-progress-bar";

import ArrowLeft from "../../images/ic-arrow-left.svg";
import ArrowRight from "../../images/ic-arrow-right.svg";
import Icon from "../UI/Icon/Icon";
import { getHeaders } from "../../helpers/getHeaders";
import axios from "../../axios-instance";
import queryString from "query-string";
import NewLoader from "../NewLoader/NewLoader";
import moment from "moment";

const pageSize = 1;

export const EventsDetails = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(1);
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const getData = async () => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const params = {
      page: pageNumber,
      pageSize,
      filter: selectedIndex === 0 ? "upcoming" : "completed",
    };
    const queryParams = queryString.stringify(params, { encode: false });

    const { data } = await axios.get(`/Events/EventList?${queryParams}`, {
      headers: getHeaders(user.token),
    });
    if (data.list && data.list.length) {
      setEvent(data.list[0]);
    }
    setTotal(data.total);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [pageNumber, selectedIndex]);

  const handlePage = (action) => {
    switch (action) {
      case "next":
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages >= pageNumber + 1) {
          setPageNumber(pageNumber + 1);
        }
        break;
      case "previous":
        if (pageNumber - 1) {
          setPageNumber(pageNumber - 1);
        }
        break;
      default:
        break;
    }
  };

  const onSelect = (i) => {
    setSelectedIndex(i);
    setPageNumber(1);
  };

  const renderHeader = () => (
    <div className="dashboard__card-header">
      <h6 className="dashboard__title">{event.eventName}</h6>
      <div className="dashboard__actions">
        <button
          className="dashboard__actions-btn"
          onClick={() => handlePage("previous")}
        >
          <img src={ArrowLeft} alt="Minus Time" />
        </button>
        <p>
          {pageNumber} / {Math.ceil(total / pageSize)}
        </p>
        <button
          className="dashboard__actions-btn"
          onClick={() => handlePage("next")}
        >
          <img src={ArrowRight} alt="Add Time" />
        </button>
      </div>
    </div>
  );

  const renderContent = () => {
    if (loading) {
      return <NewLoader />;
    }
    if (!event) {
      return (
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 400,
          }}
        >
          No Events
        </p>
      );
    }
    return (
      <>
        {renderHeader()}
        <EventInfo event={event} />
        <EventGraph ticketTemplates={event.ticketTemplates} />
      </>
    );
  };

  return (
    <div className="dashboard__events-details">
      <Tabs selectedIndex={selectedIndex} onSelect={onSelect}>
        <TabList>
          <Tab>
            <div className="page-title">Upcoming Events</div>
          </Tab>
          <Tab>
            <div className="page-title">Completed Events</div>
          </Tab>
        </TabList>
        <TabPanel>{renderContent()}</TabPanel>
        <TabPanel>{renderContent()}</TabPanel>
      </Tabs>
    </div>
  );
};

const EventInfo = ({ event }) => (
  <div className="dashboard__event-info">
    <img
      className="dashboard__event-info-img"
      src={event.imageUrl}
      alt="Event Img"
    />
    <div className="dashboard__event-info-items">
      <div className="dashboard__event-info-item">
        <Icon />
        <p className="dashboard__event-info-item-label">Time:</p>
        <p className="dashboard__event-info-item-text">
          {moment(event.startDate).format("YYYY-MM-DD HH:mm")} -{"  "}
          {moment(event.endDate).format("YYYY-MM-DD HH:mm")}
        </p>
      </div>
      <div className="dashboard__event-info-item-item">
        <Icon />
        <p className="dashboard__event-info-item-label">Place:</p>
        <p className="dashboard__event-info-item-text">{event.place}</p>
      </div>
      <div className="dashboard__event-info-item">
        <Icon />
        <p className="dashboard__event-info-item-label">Minimum age:</p>
        <p className="dashboard__event-info-item-text">{event.minimumAge}</p>
      </div>
    </div>
  </div>
);

const EventGraph = ({ ticketTemplates = [] }) => {
  const renderItem = ({ allowedToSell, capacity, name }) => (
    <div className="dashboard__event-graph-item">
      <div className="dashboard__event-graph-header">
        <p>{name}</p>
        <p>
          {capacity - allowedToSell} / {capacity}
        </p>
      </div>
      <ProgressBar
        height={"8px"}
        maxCompleted={capacity}
        completed={capacity - allowedToSell}
        isLabelVisible={false}
        bgColor="#6071B5"
        baseBgColor="#F2F4FE"
      />
    </div>
  );

  const totalItem = ticketTemplates.reduce(
    (accumulator, item) => {
      const { allowedToSell, capacity } = item;
      return {
        ...accumulator,
        allowedToSell: accumulator.allowedToSell + allowedToSell,
        capacity: accumulator.capacity + capacity,
      };
    },
    { allowedToSell: 0, capacity: 0, name: "Total" }
  );

  return (
    <div className="dashboard__event-graph">
      {renderItem(totalItem)}
      {ticketTemplates.map(renderItem)}
    </div>
  );
};
